import React from "react";
import { Link } from "react-router-dom";
import { Table, Space, Button, Popconfirm, message } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ListComponent, BaseListComponentProps } from "../BaseComponent";
import {
  SearchRequest,
  SpecieDeleteRequest,
} from "../../services/api/interfaces/ApiRequest";
import { Pagination } from "components/Pagination";

type SpecieListProps = BaseListComponentProps & {
  species: any;
  pagination: any;
  loading: boolean;

  history: any;
  searchOptions: any;

  loadSpecies: (args: SearchRequest) => void;
  deleteSpecie: (args: SpecieDeleteRequest) => Promise<any>;
};

export default class SpecieList extends ListComponent<SpecieListProps> {
  static defaultProps = {
    loading: false,
  };

  tableColumns = [
    {
      title: "UUID",
      dataIndex: "uuid",
      key: "uuid",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.uuid - b.uuid,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => a.name - b.name,
    },
    {
      title: "Actions",
      key: "action",
      align: "right",
      render: (text: string, record: any) => (
        <Space size="middle">
          <Link
            to={`specie/${record.uuid}`}
            ref={(refs) => this.actionRefs.edit.push(refs)}
          >
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>

          <div ref={(refs) => this.actionRefs.delete.push(refs)}>
            <Popconfirm
              title="Are you sure about deleting this species?"
              placement="topLeft"
              onConfirm={() => this.handleDelete(record.uuid)}
            >
              <Button type="dashed" shape="round" icon={<DeleteOutlined />} />
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ] as any;

  protected load() {
    this.searchOptions.search = {
      ...this.searchOptions.search,
      ...this.props.searchOptions.search,
    };

    this.props.loadSpecies(this.searchOptions);
  }

  handleDelete = async (uuid: string) => {
    const { deleteSpecie } = this.props;

    await deleteSpecie({
      specie_uuid: uuid,
    });

    message.success("Specie deleted successfully!");
  };

  render() {
    const { loading, pagination, species, loadSpecies } = this.props;

    return (
      <>
        <Table
          loading={loading}
          rowKey="uuid"
          columns={this.tableColumns}
          pagination={false}
          dataSource={species}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, loadSpecies)
          }
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={species?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadSpecies)
          }
        />
      </>
    );
  }
}
